/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsquerySalesarticlesSummaryIdGet$Params {
  id: string;
}

export function apiProductsquerySalesarticlesSummaryIdGet(http: HttpClient, rootUrl: string, params: ApiProductsquerySalesarticlesSummaryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SalesArticleSummary>> {
  const rb = new RequestBuilder(rootUrl, apiProductsquerySalesarticlesSummaryIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SalesArticleSummary>;
    })
  );
}

apiProductsquerySalesarticlesSummaryIdGet.PATH = '/api/productsquery/salesarticles/summary/{id}';
